import * as React from "react";
import { useEffect, useState } from "react";
import { Form, FormField, Radio } from "semantic-ui-react";

interface OwnProps {
  name: string;
  included: boolean;
  onUpdate: (v: boolean) => void;
  trueLabel?: string;
  falseLabel?: string;
  readOnly?: boolean;
}

type Props = OwnProps;

const EligibilityRadioFC: React.FC<Props> = ({ name, included, onUpdate, trueLabel, falseLabel, readOnly }) => {
  const [value, setValue] = useState(included ? "included" : "excluded");

  useEffect(() => {
    setValue(included ? "included" : "excluded");
  }, [included]);

  const updateValue = (v: string, checked: boolean | undefined) => {
    if (checked) {
      setValue(v);
      onUpdate(v == "included");
    }
  };

  return (
    <Form>
      <FormField>
        <Radio
          label={trueLabel || "Included"}
          name={name}
          value="included"
          checked={value === "included"}
          onChange={(_, data) => updateValue(data.value!.toString(), data.checked)}
          disabled={readOnly}
        />
      </FormField>
      <FormField>
        <Radio
          label={falseLabel || "Excluded"}
          name="checkboxRadioGroup"
          value="excluded"
          checked={value === "excluded"}
          onChange={(_, data) => updateValue(data.value!.toString(), data.checked)}
          disabled={readOnly}
        />
      </FormField>
    </Form>
  );
};

export const EligibilityRadio = EligibilityRadioFC;
